import { useState } from "react";

export type FailedImages = {
  /** The URL, or `null` when it is unset or has failed to load */
  usable: (url: string | null) => string | null;
  /** Marks a URL as failed (an `<img>` `onError`) */
  fail: (url: string) => void;
};

/**
 * Header images (hero, logo) that failed to load while the page is shown. A failed image is
 * treated as unset (R3), so the shell's container padding and the header layout follow the rules
 * for its absence. Kept per URL, so new page data with another image still tries it.
 */
export const useFailedImages = (): FailedImages => {
  const [failed, setFailed] = useState<readonly string[]>([]);
  return {
    usable: (url) => (url && !failed.includes(url) ? url : null),
    fail: (url) => {
      setFailed((urls) => (urls.includes(url) ? urls : [...urls, url]));
    },
  };
};
